'use strict';

module.exports = angular.module('ui.utils.masks', [
	require('./global/global-masks'),
	require('./us/us-masks')
]).name;



//////////////////
// WEBPACK FOOTER
// ../~/angular-input-masks/src/angular-input-masks.us.js
// module id = 36
// module chunks = 3